import { render, staticRenderFns } from "./UserPurchaseModal.vue?vue&type=template&id=ef05d1c2&scoped=true"
import script from "./UserPurchaseModal.vue?vue&type=script&lang=js"
export * from "./UserPurchaseModal.vue?vue&type=script&lang=js"
import style0 from "./UserPurchaseModal.vue?vue&type=style&index=0&id=ef05d1c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef05d1c2",
  null
  
)

export default component.exports